import { getSelectedAccountMailboxInfo } from 'owa-account-source-list-store';
import { getCategoryNameFromId, getMasterCategoryList } from 'owa-categories';
import { getListViewTypeForFolder } from 'owa-mail-folder-store';
import { TableQuery } from 'owa-mail-list-store';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import createMailFolderTableQuery from './createMailFolderTableQuery';

/**
 * Create the table query to load a category search folder
 * @param categoryId the id of the category
 * @return tableQuery the tableQuery that needed to load a mail folder
 */
export default function createMailCategoryFolderTableQuery(categoryId: string): TableQuery {
    const categoryName = getCategoryNameFromId(
        categoryId,
        getMasterCategoryList(getSelectedAccountMailboxInfo())
    );
    const mailCategoryTableQuery = createMailFolderTableQuery(
        folderNameToId('msgfolderroot'),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (20,34): Argument of type 'null' is not assignable to parameter of type 'string'.
        // @ts-expect-error
        getListViewTypeForFolder(null),
        'category',
        FocusedViewFilter.None,
        'UserCategory',
        categoryName
    );

    return mailCategoryTableQuery;
}
